export const allowlistAddresses = [


    ["0xa17cc03654e43576fd890c3aeeb3670fb70dd540",11],
    ["0x86eb8be678274ba4c47af17fa8511c3f9c631bbc",11],
    ["0x635cab3d1df1c87e3c6534b85f24cc794d883698",11],
    ["0x5c3d97f9a3b7938ca043b3a671b4b05291a94823",11],
    ["0xa18d39c37a6e78b91b1f36fc7d6ed91fcdb597e3",11],
    ["0x7e45c617350395ba24210c3b0f926f9973177b9f",11],
    ["0x89fc135b9edd480d4945afb36f67b609e73e1b90",11],
    ["0x74433ede05e90b31d2c36cfd0be51921b438e500",11],
    ["0x6112b496e43a05e61797743a45640df13efcf053",11],
    ["0xbab1a10d74da9943b593c3eadf95cd41b968a991",11],
    ["0x826d434d6fb50a988a7823adc16db3fd11fa29e9",11],
    ["0x1a3326bf12589ee53b3f796c9d376ea3df60d459",11],
    ["0x93a9426951e26f019e61dff6d222648b9d12a8f4",11],
    ["0x03eeba1287dbbc6e5a10e3c916976a27ad00fe29",11],
    ["0x2bd8afa9bdfd2899326b833507bd4dd0bfd846df",11],
    ["0xdecf4b112d4120b6998e5020a6b4819e490f7db6",11],
    

]